import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout6({ data, files }: LayoutProps) {
 return (
  <div className="container">
   <div className="flex flex-wrap">
    <div
     className="w-full pt-2.5 sm:w-full md:w-2/3 lg:w-2/3"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[0].src}
     />
    </div>
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/3 lg:w-1/3"
     data-aos="fade-right"
    >
     <CaseVideo videoIndex={0} add="embed-responsive tr" video={files[1].src} />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[2].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[4].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[6].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div
     className="w-1/3 pt-2.5 sm:w-1/3 md:w-1/3 lg:w-1/3 pr-1.5"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[7].src}
     />
    </div>
    <div
     className="w-1/3 pt-2.5 sm:w-1/3 md:w-1/3 lg:w-1/3 px-0.5"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[8].src}
     />
    </div>
    <div
     className="w-1/3 pt-2.5 sm:w-1/3 md:w-1/3 lg:w-1/3 pl-1.5"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[9].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[10].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[11].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/3 lg:w-1/3 pr-3.5 max-[768px]:pr-0"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[12].src}
      add="fullHeight"
     />
    </div>
    <div
     className="w-full pt-2.5 sm:w-full md:w-2/3 lg:w-2/3"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[13].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[14].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[15].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[16].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseVideo
      videoIndex={0}
      add="main-embed-container"
      video={files[3].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[17].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseVideo
      videoIndex={0}
      add="main-embed-container"
      video={files[5].src}
     />
    </div>
   </div>
  </div>
 )
}
